module.exports = __webpack_public_path__ + "img/1661.01e7fd44.jpg";